import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";

export default function DonationSuccess() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-5 py-16 bg-gradient-to-br from-[#FFBF69]/25 via-[#FDFFFC] to-[#FDE74C]/25">
      <div className="max-w-md w-full text-center" data-testid="donation-success">
        <div className="w-24 h-24 rounded-full bg-[#FF9F1C] text-white grid place-items-center mx-auto shadow-[0_20px_60px_rgb(255,159,28,0.35)]">
          <Heart className="w-14 h-14" fill="currentColor" />
        </div>
        <h1 className="mt-8 font-display font-black text-5xl tracking-tight">Thank you 💛</h1>
        <p className="mt-4 text-lg text-[#7A7D8C]">Your donation just fueled more cubes, more snacks, and more first-competition smiles. Watch for a receipt in your inbox.</p>
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-[#FF9F1C] text-white font-bold shadow-[0_12px_30px_rgb(255,159,28,0.35)]">Back home <ArrowRight className="w-4 h-4" /></Link>
          <Link to="/competitions" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white border border-slate-200 font-bold hover:border-[#FF9F1C] hover:text-[#FF9F1C]">See upcoming events</Link>
        </div>
      </div>
    </div>
  );
}
